import { render, staticRenderFns } from "./ResetInput.vue?vue&type=template&id=3aae84bb"
import script from "./ResetInput.vue?vue&type=script&lang=js"
export * from "./ResetInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports